import React, { Component } from 'react';
import { useHistory } from 'react-router-dom';
import DriverFaq from '../Static/DriverFaq';

const DriverFaqRouter = () => {
  const history = useHistory();
  const path = history.location.pathname;
  const city = path.split('/')[1];

  return <DriverFaq operatingCity={city} />;
};

export default DriverFaqRouter;



// WEBPACK FOOTER //
// ./src/components/DriverFaqRouter/index.js